export default Object.freeze({
  NOTICE_ADDITIONAL: '해당 부가서비스를 사용중이시거나 지원하지 않는 쇼핑몰은 선택이 불가합니다.',
  ALERT_SELECT_MALL: '쇼핑몰을 선택해주세요.',
  ALERT_NO_MALL_AVAILABLE_CHOICE: `신청 가능한 쇼핑몰이 없습니다.
현재 해당 부가서비스를 사용중이거나
지원하지 않는 쇼핑몰입니다.`,
});
